// extracted by mini-css-extract-plugin
export default {"inputBlock":"OrderRibbonSettings_inputBlock__iYUqw","unitColumn":"OrderRibbonSettings_unitColumn__ivczy","form":"OrderRibbonSettings_form__mC0zj"};